import React from 'react';
import { 
  Pill, 
  Users, 
  Clock, 
  Globe2, 
  Plane, 
  FileText, 
  Building2,
  Car,
  Home,
  Languages,
  HeartPulse,
  Phone
} from 'lucide-react';
import './Mt5.css';

const Mt5: React.FC = () => {
  return (
    <div className="mt5">
      {/* Hero Section */}
      <div className="hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1>International Medical Tourism</h1>
          <p>World-Class Healthcare Beyond Borders</p>
        </div>
      </div>

      {/* Why Choose Section */}
      <section className="why-choose-section container">
        <h2 className="section-title">Why Choose International Healthcare?</h2>
        <div className="benefits-grid">
          <div className="benefit-card">
            <Pill className="benefit-icon" />
            <h3>Advanced Treatment Options</h3>
            <p>Access to over 400 new drugs and technologies not available in many countries</p>
            <ul className="benefit-list">
              <li>Latest medical innovations</li>
              <li>Cutting-edge equipment</li>
              <li>Advanced treatment protocols</li>
            </ul>
          </div>

          <div className="benefit-card">
            <Users className="benefit-icon" />
            <h3>Personalized Care Model</h3>
            <p>Multidisciplinary team (MDT) approach for comprehensive treatment</p>
            <ul className="benefit-list">
              <li>Expert team collaboration</li>
              <li>Customized treatment plans</li>
              <li>Holistic patient care</li>
            </ul>
          </div>

          <div className="benefit-card">
            <Clock className="benefit-icon" />
            <h3>Clinical Trial Access</h3>
            <p>Opportunities to participate in groundbreaking medical research</p>
            <ul className="benefit-list">
              <li>Innovative treatments</li>
              <li>Expert supervision</li>
              <li>Latest medical advances</li>
            </ul>
          </div>

          <div className="benefit-card">
            <Globe2 className="benefit-icon" />
            <h3>Patient-Centered Experience</h3>
            <p>Streamlined, appointment-based care with minimal waiting times</p>
            <ul className="benefit-list">
              <li>Efficient scheduling</li>
              <li>Personalized attention</li>
              <li>Comfortable environment</li>
            </ul>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section className="services-section">
        <div className="container">
          <h2 className="section-title">Comprehensive Support Services</h2>
          
          <div className="service-stages">
            <div className="stage">
              <h3>Pre-Travel Support</h3>
              <div className="services-grid">
                <div className="service-card">
                  <FileText className="service-icon" />
                  <h4>Medical Consultation</h4>
                  <p>Expert evaluation and hospital recommendations</p>
                </div>
                <div className="service-card">
                  <Building2 className="service-icon" />
                  <h4>Hospital Arrangements</h4>
                  <p>Appointments with leading medical facilities</p>
                </div>
                <div className="service-card">
                  <Languages className="service-icon" />
                  <h4>Document Translation</h4>
                  <p>Medical records and documentation services</p>
                </div>
                <div className="service-card">
                  <Plane className="service-icon" />
                  <h4>Travel Planning</h4>
                  <p>Visa assistance and travel arrangements</p>
                </div>
              </div>
            </div>

            <div className="stage">
              <h3>During Your Stay</h3>
              <div className="services-grid">
                <div className="service-card">
                  <Car className="service-icon" />
                  <h4>Transportation</h4>
                  <p>Airport transfers and local transportation</p>
                </div>
                <div className="service-card">
                  <Home className="service-icon" />
                  <h4>Accommodation</h4>
                  <p>Comfortable lodging arrangements</p>
                </div>
                <div className="service-card">
                  <Languages className="service-icon" />
                  <h4>Medical Interpretation</h4>
                  <p>Professional medical translation services</p>
                </div>
                <div className="service-card">
                  <HeartPulse className="service-icon" />
                  <h4>Care Coordination</h4>
                  <p>24/7 support and emergency assistance</p>
                </div>
              </div>
            </div>

            <div className="stage">
              <h3>Post-Treatment Care</h3>
              <div className="services-grid">
                <div className="service-card">
                  <FileText className="service-icon" />
                  <h4>Medical Records</h4>
                  <p>Translation and documentation services</p>
                </div>
                <div className="service-card">
                  <Phone className="service-icon" />
                  <h4>Follow-up Care</h4>
                  <p>Ongoing consultation with specialists</p>
                </div>
                <div className="service-card">
                  <Globe2 className="service-icon" />
                  <h4>Remote Support</h4>
                  <p>Continued assistance after return</p>
                </div>
                <div className="service-card">
                  <Users className="service-icon" />
                  <h4>Local Coordination</h4>
                  <p>Liaison with home healthcare providers</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section container">
        <div className="contact-content">
          <div className="contact-text">
            <h2>Start Your Medical Journey</h2>
            <p>
              Our dedicated team is here to help you access world-class medical care. 
              Contact us to discuss your needs and learn more about our comprehensive 
              medical tourism services.
            </p>
            <div className="contact-info">
              <div className="info-item">
                <Phone className="info-icon" />
                <div>
                  <h4>24/7 Support</h4>
                  <p>+886-2-1234-5678</p>
                </div>
              </div>
              <div className="info-item">
                <Globe2 className="info-icon" />
                <div>
                  <h4>Email Us</h4>
                  <p>care@medicaltourism.com</p>
                </div>
              </div>
            </div>
          </div>
          <div className="contact-image">
            <img 
              src="https://images.unsplash.com/photo-1538108149393-fbbd81895907?auto=format&fit=crop&q=80&w=2000"
              alt="Medical Consultation"
              loading="lazy"
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Mt5;